import { Component } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import BranchToSectionApprovalHierarchy from '../../../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { BUTTON_STYLES } from '../constants';

class SearchFilters extends Component {
    render() {
        const { 
            searchLevel, 
            onSearchLevelChange, 
            onDropdownValuesChange, 
            onSchedulerRefresh 
        } = this.props;

        return (
            <div>
                <div className="ma-main">
                    <div className="datatable-crud-demo ma-m30 mx-2 mb-5">
                        <div className="flex">
                            <div className="flex flex-column justify-content-center align-items-center mt-3">
                                <RadioButton 
                                    inputId="ingredient1" 
                                    onChange={(e) => onSearchLevelChange(1)} 
                                    checked={searchLevel === 1} 
                                />
                            </div>
                            <div>
                                <BranchToSectionApprovalHierarchy 
                                    selectedValue={searchLevel} 
                                    setValues={onDropdownValuesChange} 
                                    approvalType={'studentStatusChange'} 
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-content-end ma-m30 mx-2">
                        <Button
                            className="p-button-rounded p-button-outlined"
                            style={BUTTON_STYLES.REFRESH}
                            icon="pi pi-refresh"
                            label="Refresh Data"
                            onClick={onSchedulerRefresh}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchFilters;
